// Centrale navigatieconfiguratie: sidebar-groepen + Overzicht-tegels.
// `pageKey` moet blijven matchen met PageCatalog in de API (module Platform, gelezen door auth/me)
// en de route→key-mapping in components/ProtectedRoute.jsx. Alleen labels, groepen en
// iconen zijn hier vrij; key/pageKey/path blijven ongewijzigd (PageCatalog en
// bestaande bladwijzers hangen eraan).
//
// Termijnrekeningen hebben geen eigen menu-item meer: ze staan in Liquiditeit (detailpaneel);
// /term-deposits stuurt door (App.jsx), de page-key blijft in routeKeys.js.
//
// Elk icoon komt één keer voor. De drie verwerkingsstappen (import, boeken, Exact) tonen
// een stapnummer in plaats van een icoon.

export const NAV_GROUPS = [
  {
    title: "Start",
    items: [
      { key: "home", pageKey: "home", label: "Overzicht", path: "/", icon: "home" },
      // Centrale werklijst (signalen uit planning, beleid, fees en bank). Teller = open items.
      { key: "worklist", pageKey: "worklist", label: "Te doen", path: "/worklist", icon: "check", badgeKey: "worklistOpen" },
    ],
  },
  {
    title: "Planning",
    items: [
      {
        key: "cashflowForecast",
        pageKey: "cashflowForecast",
        label: "Liquiditeit",
        path: "/cashflow-forecast",
        icon: "trend",
      },
      { key: "saa", pageKey: "saa", label: "Beleggingsbeleid", path: "/saa", icon: "layers" },
      { key: "contracts", pageKey: "contracts", label: "Contracten & fees", path: "/contracts", icon: "file" },
    ],
  },
  {
    title: "Bankflow",
    items: [
      // Documenten bovenaan: lezen voor alle rollen (ook wie de bankflow zelf niet ziet).
      {
        key: "bankDocuments",
        pageKey: "bankDocuments",
        label: "Documenten",
        path: "/bank-documents",
        icon: "archive",
      },
      // Kwartaaldossier: alle bankdocumenten per kwartaal + verwerkingsstatus (route en page-key bleven "bankflow").
      { key: "bankflow", pageKey: "bankflow", label: "Kwartaaldossier", path: "/bankflow", icon: "activity" },
      { key: "bankImport", pageKey: "bankImport", label: "Bank import", path: "/bank-import", step: 1 },
      {
        key: "bankProcessing",
        pageKey: "bankProcessing",
        label: "Boeken",
        path: "/bank-processing",
        step: 2,
        badgeKey: "processingPending",
      },
      { key: "exactOnline", pageKey: "exactOnline", label: "Exact Online", path: "/exact-online", step: 3 },
    ],
  },
  {
    title: "Koersen",
    items: [
      { key: "marketRates", pageKey: "marketRates", label: "Marktkoersen", path: "/market-rates", icon: "pencil" },
      { key: "fixedIncome", pageKey: "fixedIncome", label: "Vastrentend", path: "/fixed-income", icon: "bars" },
      {
        key: "marketDataBootstrap",
        pageKey: "marketDataBootstrap",
        label: "Marktdata",
        path: "/market-data-bootstrap",
        icon: "refresh",
      },
      {
        key: "portfolioUpload",
        pageKey: "portfolioUpload",
        label: "Portefeuille-upload",
        path: "/portfolio-upload",
        icon: "upload",
      },
    ],
  },
  {
    title: "Stamdata",
    items: [
      { key: "assets", pageKey: "assets", label: "Assets", path: "/assets", icon: "list" },
      { key: "lookups", pageKey: "lookups", label: "Lookups", path: "/lookups", icon: "settings" },
      // Juridische entiteiten (eigenaars) en de entiteit per bankrekening (issue #52).
      { key: "legalEntities", pageKey: "legalEntities", label: "Entiteiten", path: "/legal-entities", icon: "users" },
      {
        key: "bankProfiles",
        pageKey: "bankProfiles",
        label: "Bankprofielen",
        path: "/bank-profiles",
        icon: "bank",
        badgeKey: "bankProfileProposals",
      },
      { key: "exactJournals", pageKey: "exactJournals", label: "Dagboeken", path: "/exact-online/journals", icon: "book" },
      {
        key: "exactGL",
        pageKey: "exactGL",
        label: "Grootboek",
        path: "/exact-online/general-ledger",
        icon: "download",
      },
    ],
  },
  {
    title: "Systeem",
    items: [
      { key: "diagnostics", pageKey: "diagnostics", label: "Diagnose", path: "/diagnostics", icon: "info" },
      // Enkel admin (PageCatalog): feedback van de LLM over de MCP-tools en skills.
      { key: "feedback", pageKey: "feedback", label: "Feedback", path: "/feedback", icon: "message" },
    ],
  },
];

// Breadcrumb-hulp: pad → { group, item }
export function findNavItemByPath(pathname) {
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      if (item.path === pathname) return { group: group.title, item };
    }
  }
  // Prefix-match voor subroutes (bv. /exact-online/journals valt al exact)
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      if (item.path !== "/" && pathname.startsWith(item.path)) return { group: group.title, item };
    }
  }
  return null;
}

// Vlakke lijst (afgeleid) voor tegels/filters.
export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, group: g.title })));

export default NAV_ITEMS;
